import React from 'react';
import PropTypes from 'prop-types';
import FeatureWireModal from './feature-wire-components/feature-wire-modal';
import useFeatureWireStore from './feature-wire-components/state-hooks';
import useGetAllFeatureable from '../../../../services/wire/featureable-service';

export default function FeatureWireControl({ wireId }) {
  const set = useFeatureWireStore(state => state.set);
  const [, getFeatureable] = useGetAllFeatureable(wireId);

  const showModal = e => {
    e && e.preventDefault();

    getFeatureable().then(resp => {
      set(state => {
        state.showModal = true;
        state.featureable = resp.data.featureable;
        state.selectedFeatureable = resp.data.selectedFeatureable;
      });
    }).catch(() => {
      set(state => {
        state.showModal = true;
        state.featureable = { author: null, mentions: [] };
      });
    });
  };

  return (
    <>
      <aside className="sidebar-item no-top-margin">
        <section className="form-group no-top-margin">
          <a href="#" className="sidebar-item-link" onClick={showModal}>Feature Wire on Profile/s</a>
        </section>
      </aside>
      <FeatureWireModal wireId={wireId} />
    </>
  );
}

FeatureWireControl.propTypes = { wireId: PropTypes.number.isRequired };
